import { ofType } from 'redux-observable';
import { of } from 'rxjs/observable/of';
import { forkJoin } from 'rxjs/observable/forkJoin';
import { map } from 'rxjs/operators/map';
import { switchMap } from 'rxjs/operators/switchMap';
import { catchError } from 'rxjs/operators/catchError';
import { types as actions, areaExpandedAction } from '../../reducers/actions';
import { IndoorMappingService } from '../../services';
import { retryAuthentication } from '../../utils/epics/retryAuthentication';

export default function (action$, store) {
  return action$.pipe(
    ofType(actions.EXPAND_AREA),
    switchMap(action =>
      forkJoin(
        of(action.area),
        !action.ignoreFile && action.area && action.area.indoorMapping && action.area.indoorMapping.id
          ? IndoorMappingService.get(action.area.id, store)
          : of({})
      ).pipe(
        map(([area, indoorMappingResponse]) => {
          if (indoorMappingResponse && indoorMappingResponse.file) {
            const imgObj = {
              id: indoorMappingResponse.id,
              account: {
                href: indoorMappingResponse.account.href
              },
              href: indoorMappingResponse.file.href,
              name: indoorMappingResponse.name,
              preview: indoorMappingResponse.file.imgData
            }
            area.file = [imgObj];
            delete indoorMappingResponse.file.imgData;
          }
          if (action.area && action.area.indoorMapping && action.area.indoorMapping.id) {
            indoorMappingResponse.id = action.area.indoorMapping.id;
          }
          area.indoorMapping = indoorMappingResponse;
          return areaExpandedAction(area);
        }),
        catchError(retryAuthentication(action$, 'epics/areas/areaExpand'))
      )
    )
  );
}



// WEBPACK FOOTER //
// ./src/epics/areas/areaExpand.js